import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { addProductToCart, getCart, removeProductFromCart } from '@/queries/cart'
import { filterApi } from '@/queries/search'
import type { Product } from '@/types'
import type { CartItem } from '@/types/shop'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Minus, Plus, ShoppingCart } from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { AxiosError } from 'axios'
import ShoppingCard from '@/components/shoping-card'
import { buildCategories } from '@/lib/utils'

export const Route = createFileRoute('/shop/')({
  component: ShopPage,
})

function ShopPage() {
  const [categories, setCategories] = useState<Array<any>>([])
  const shopItemsQuery = useQuery({
    queryFn: () => filterApi('product', {type: 'cart', categories:'categories'}),
    queryKey: ['shop-items'],
  })

  const getCartQuery = useQuery({
    queryFn: () => getCart(),
    queryKey: ['shoping-cart'],
  })

  useEffect(()=>{
    if (getCartQuery.data) {
      setCart(Object.values(getCartQuery.data.data.cart.items))
    }
  }, [getCartQuery.data])


  

  // useEffect(()=> {
  //   if (shopItemsQuery.data) {
  //     console.log(buildCategories(shopItemsQuery.data.data.data))
  //     setCategories(buildCategories(shopItemsQuery.data.data.data))
  //   }
  // }, [shopItemsQuery.data])

  const [cart, setCart] = useState<Array<CartItem>>([])

  // اضافه کردن محصول یا افزایش تعداد
const addToCart = (productId: number) => {
  setCart(carts => {
    const product = shopItemsQuery.data?.data?.data?.find(
      (pr: Product) => pr.id === productId
    );

    if (!product) return carts;

    const existingIndex = carts.findIndex(
      (item: CartItem) => item.product.id === product.id
    );

    if (existingIndex !== -1) {
      // اگر هست quantity رو +1 کن
      return carts.map((item, idx) =>
        idx === existingIndex
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
    } else {
      // اگر نیست quantity = 1 اضافه کن
      return [
        ...carts,
        {
          quantity: 1,
          discount_value: 0,
          product,
        } as CartItem,
      ];
    }
  });
};

// کم کردن محصول یا حذف در صورت صفر شدن
const removeFromCart = (productId: number) => {
  setCart(carts => {
    const existingIndex = carts.findIndex(
      (item: CartItem) => item.product.id === productId
    );

    if (existingIndex === -1) {
      // محصول توی سبد نیست
      return carts;
    }

    const item = carts[existingIndex];

    if (item.quantity > 1) {
      // کم کردن یک عدد
      return carts.map((it, idx) =>
        idx === existingIndex
          ? { ...it, quantity: it.quantity - 1 }
          : it
      );
    } else {
      // اگر quantity = 1 بود و کم شد → حذف کامل از سبد
      return carts.filter((_, idx) => idx !== existingIndex);
    }
  });
};

  
  const addCartMutation = useMutation({
    mutationFn: ({product_id, cart_key}: {product_id: number, cart_key?: any}) => addProductToCart(product_id, cart_key),
    onSuccess(_, variables) {
      addToCart(variables.product_id)
    },
    onError(error: AxiosError<{message: string}>) {
      
      if (error.response?.data?.message.includes('no item in warehouse')) {
        toast.error('محصول کافی در انبار موجود نمی باشد')

      }
    }
  })

  const removeCartMutation = useMutation({
    mutationFn: ({product_id}: {product_id: number, cart_key?: any}) => removeProductFromCart(product_id),
    onSuccess(_, variables) {
      removeFromCart(variables.product_id)
    },
  })


  return <>
  <div className='flex justify-between items-center m-4'>
    <p className='text-xl font-bold'>فروشگاه</p>
    <div className='flex items-center gap-2'>

    <DropdownMenu>
      <DropdownMenuTrigger asChild>

    <Button variant="outline" size="icon" className='relative'>
    <ShoppingCart />
    {cart.length > 0 ? <div className='size-5 rounded-full bg-red-500 text-white flex items-center justify-center text-xs absolute -top-1 -right-1'>
      {cart.reduce((a, b) => a + b.quantity, 0)}
      </div>: ''}
    </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className='w-80 p-4' align="end">
        <p>سبد خرید</p>
        <DropdownMenuSeparator />
        
        {cart.length > 0 ? 
        <>
        <div className='flex flex-col gap-4 divide-y divide-border max-h-72 overflow-y-auto'>

        {cart.map(item => (
          <div key={item.product.id} className='py-4 flex flex-col gap-4'>
          <div className='flex justify-between items-center'> 

          <p className='text-lg font-bold'>
            {item.product.name}
            </p>

          <p>{Intl.NumberFormat().format(item.product.price)}</p>
          </div>
          <div className='flex justify-between items-end'>

          <div className='flex justify-between items-center bg-secondary rounded-lg w-32'>

          <Button size="icon" onClick={() => addCartMutation.mutate({product_id: item.product.id})}>
            <Plus />
          </Button>

          <p>{item.quantity}</p>


          <Button size="icon" onClick={() => removeCartMutation.mutate({product_id: item.product.id})}>
            <Minus />
          </Button>
          </div>

          {Intl.NumberFormat().format(item.product.price * item.quantity)} ریال

          </div>


          
          </div>
        ))}
        </div>
        <Separator />
        <div className='flex justify-between items-end py-2'>
          <div>
          <p className='text-muted-foreground text-sm'>
            مجموع پرداختی
          </p>
          <p className='text-xl font-bold'>
          {Intl.NumberFormat().format(cart.reduce((acc, curr) => {
            return acc + (curr.product.price * curr.quantity)
          }, 0))} ریال
          </p>
          </div>
          <Link to="/shop/cart">
          <Button>
            مشاهده سبد خرید
          </Button>
          </Link>
        </div></>: <>
          
          <p className='text-center font-bold py-4'>سبد خرید شما خالی می باشد</p>
        </>}
      </DropdownMenuContent>
    </DropdownMenu>
    <Link to="/shop/orders">
    <Button>
      سفارشات شما
    </Button>
    </Link>
    </div>

  </div>

  {shopItemsQuery.isFetching ? <div className='grid grid-cols-5 gap-5'>
  {Array.from({length: 15}).map((_, idx) =>(
    <div key={idx}>
    <Skeleton className='size-52 w-full'/>
    <Skeleton  className='h-5 mt-2'/>
    </div>

  ))}
  
  </div> : shopItemsQuery.data?.data.length < 1 ? <>
    <div className='w-full h-full items-center justify-center flex'>
      <p className='text-muted-foreground'>محصولی یافت نشد!</p>
    </div>
  </> : <div className='flex flex-col gap-2'>
    {/* {categories?.map(category => <section className='my-4'>
      <div className=''>
        <p className='text-xl font-bold'>
        {category.text}
        </p>
      </div>
      <div>
      <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 mt-2'>
        {category.products.map((item: any) => (
      <ShoppingCard item={item} cart={cart} addCartMutation={addCartMutation} removeCartMutation={removeCartMutation}/>
      ))}
      </div>
      </div>
    </section>)} */}
  <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5'>
    {shopItemsQuery.data?.data?.data?.map((item: any) => (
      <ShoppingCard item={item} cart={cart} addCartMutation={addCartMutation} removeCartMutation={removeCartMutation}/>
      ))}
  </div>
      </div>}
    
  </>
}
